import type { Component } from 'vue'

export enum NotificationTypeIds {
  CERTIFICATE_ISSUED = 'CERTIFICATE_ISSUED',
  BADGE_ISSUED = 'BADGE_ISSUED',
  WELCOME_BADGE_ISSUED = 'WELCOME_BADGE_ISSUED',
  COURSE_POST_COMMENT = 'COURSE_POST_COMMENT',
  COMMUNITIES_NEW_POST_FOLLOWERS = 'COMMUNITIES_NEW_POST_FOLLOWERS',
  COMMUNITIES_NEW_EVENT_CREATED = 'COMMUNITIES_NEW_EVENT_CREATED',
  COMMUNITIES_POST_GO_LIVE = 'COMMUNITIES_POST_GO_LIVE',
  COMMUNITIES_POST_LIKE = 'COMMUNITIES_POST_LIKE',
  EVENT_CONNECTION_REQUESTED = 'EVENT_CONNECTION_REQUESTED',
  EVENT_APP_NOTIFICATION = 'EVENT_APP_NOTIFICATION',
}

export enum SourceApp {
  COURSES = 'COURSES',
  CERTIFICATES = 'CERTIFICATES',
  COMMUNITIES = 'COMMUNITIES',
  EVENTS = 'EVENTS',
}

export interface NotificationWebProps {
  profileCardIsOpen: boolean
  appLauncherIsOpen: boolean
  notificationListIsOpen: boolean
  position: string
}

export interface NotificationItemProps {
  notification: INotification
}

export interface NotificationListProps {
  markAllRead: () => void
  notificationVisibility: 'all' | 'unread'
  loadMoreNotifications: () => void
}

export interface INotification {
  _id: string
  notificationType: string
  body: string
  redirectionUrl: string
  isRead: boolean
  avatarData: {
    avatarUrl?: string
    badgeUrl?: string
    name?: string
  }
  relativeTime?: string
  createdAt: string
  type?: string
  sourceApp?: SourceApp
  metaData?: {
    commentId?: string
    connectionId?: string
    originEventId?: string
    // Stored as a string: the in-app record shares its flattened metadata with push, whose data
    // values must be strings. Normalize before comparing (cp-events-layer `asPositiveInteger`).
    requestVersion?: number | string
    introMessage?: string
    requesterDisplayName?: string
    eventName?: string
    eventNotificationKind?: string
    deliveryKey?: string
    title?: string
  }
}

export interface NotificationItemActionsProps {
  notification: INotification
  notifications: readonly INotification[]
}

export type NotificationItemActionsResolver = (notification: INotification) => Component | undefined

export interface NotificationFilters {
  isRead?: boolean
  previousId?: string
  limit?: number
  pageSort?: 'ascending' | 'descending'
}
